import { FC, ReactNode } from "react";
import { usePositionsPanelContext } from "./position-panel-context";
import { getIsLoan } from "./utils";

interface LoanMetaProps {
  title?: ReactNode;
  healthFactorSlot: ReactNode;
  borrowingPowerUsedSlot: ReactNode;
}

export const LoanMeta: FC<LoanMetaProps> = ({
  title,
  healthFactorSlot,
  borrowingPowerUsedSlot,
}) => {
  const { positions } = usePositionsPanelContext();

  const isLoan = getIsLoan(positions);

  return (
    <div className="flex flex-col gap-10">
      {title && <div>{title}</div>}

      {isLoan && (
        <div className="flex flex-col @screen-sm:flex-row gap-6 @screen-sm:gap-12">
          <div className="@screen-sm:flex-1">{healthFactorSlot}</div>

          <div className="@screen-sm:flex-1">{borrowingPowerUsedSlot}</div>
        </div>
      )}
    </div>
  );
};
